import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { formations } from '../data/formations';
import { publics, site } from '../data/site';
import { FormationCard } from '../components/FormationCard';
import { useSeo } from '../hooks/useSeo';
export function Formations() {
  useSeo({
    title: 'Nos formations professionnelles à Joigny (Yonne) — Zillenium Academy',
    description: 'Formation digitale et réseaux sociaux, formation point de vente et commerce, formation entrepreneur et communication, formation management : 4 parcours professionnels à Joigny (89), organisme certifié Qualiopi.'
  });
  return <>
      <section className="border-b border-surface-line bg-surface-soft" data-id="element-340" data-mp="jtgfnvibfpub">
        <div className="mx-auto max-w-content px-5 py-14 lg:px-8 lg:py-16" data-id="element-341" data-mp="ezm3dd51id59">
          <h1 className="max-w-3xl text-4xl font-extrabold leading-tight text-ink md:text-[46px]" data-id="element-342" data-mp="3nfe41oj2e8o4">
            Nos formations professionnelles
          </h1>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-ink-muted" data-id="element-343" data-mp="2tfbbyrmlj0k2">
            Quatre parcours pour développer vos compétences en digital, commerce, entrepreneuriat et
            management. Formations dispensées à {site.ville} ({site.departement}), dans vos locaux ou
            à distance selon le parcours.
          </p>
          <ul className="mt-6 flex flex-wrap gap-2" data-id="element-344" data-mp="382mn4sev8ijn">
            {publics.map(p => <li key={p} className="rounded-full border border-surface-line bg-white px-3.5 py-1.5 text-sm font-medium text-brand-800" data-id="element-345" data-mp="2ah8ucxwdo5wa">
                {p}
              </li>)}
          </ul>
        </div>
      </section>

      <section className="mx-auto max-w-content px-5 py-14 lg:px-8" data-id="element-346" data-mp="2pdzjmecc8186">
        <div className="grid gap-6 md:grid-cols-2" data-id="element-347" data-mp="2pb3mgs8bdgks">
          {formations.map(f => <FormationCard key={f.slug} formation={f} data-id="element-348" data-mp="3vvmn4jo96ywz" />)}
        </div>
      </section>

      <section className="border-t border-surface-line bg-surface-soft" data-id="element-349" data-mp="4pbu9ated4gq">
        <div className="mx-auto flex max-w-content flex-col items-start gap-8 px-5 py-14 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-350" data-mp="20p2jpjbr9dju">
          <div className="max-w-2xl" data-id="element-351" data-mp="29r1wfzfqlvgz">
            <h2 className="text-2xl font-bold text-ink md:text-3xl" data-id="element-352" data-mp="29q0nq1m71l2f">
              Une question sur un programme ?
            </h2>
            <p className="mt-3 text-[17px] text-ink-muted" data-id="element-353" data-mp="25q8dlkh5j6uy">
              Nous analysons votre besoin avant toute proposition : objectifs, profil des
              bénéficiaires et éventuels besoins d’adaptation.
            </p>
          </div>
          <Link to="/contact" className="inline-flex shrink-0 items-center gap-2 rounded-lg bg-brand-900 px-6 py-3.5 text-base font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-800" data-id="element-354" data-mp="1qspq0lg7mzp3">
            Être recontacté
            <ArrowRightIcon size={18} aria-hidden data-id="element-355" data-mp="ua9wqufqfgj6" />
          </Link>
        </div>
      </section>
    </>;
}